import {
  Component,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';



export class MdlTabPanelTitleComponent {

  constructor(public vcRef: ViewContainerRef) {}

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-tab-panel-title',
  template:
    `
   <ng-content></ng-content>
   `,
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ViewContainerRef, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
